/* eslint-disable no-nested-ternary */
import styled, { css } from 'styled-components';

interface ContainerProps {
  width: string;
}

interface SelectContainerProps {
  height: string;
  focus: boolean;
  disabled: boolean | undefined;
  error: boolean;
  fontSize?: string;
  borderLeft?: boolean;
  backgroundIcon?: boolean;
  icon?: string;
}

interface MessageProps {
  error: boolean;
}

export const Container = styled.div<ContainerProps>`
  width: ${props => props.width};
  font-family: 'Roboto', Oxygen, Ubuntu, Cantarell, 'Open Sans',
    'Helvetica Neue', sans-serif;
  display: flex;
  flex-direction: column;
`;

export const SelectGroup = styled.div`
  display: flex;
  flex-direction: column;

  border-radius: 4px;
  font-weight: lighter;
  padding-left: 16px;
  border: 1px solid #bfc4ca;
  background: #ffffff;
`;

export const Label = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #444a51;
  margin-bottom: 2px;
`;

export const SelectContainer = styled.div<SelectContainerProps>`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  height: ${props => props.height};
  border: 1px solid;
  border-radius: 4px;
  border-color: ${props => (props.focus ? '#106bef' : '#bfc4ca')};
  background: #fff;

  select {
    font-family: inherit;
    width: 100%;
    height: 100%;
    border: none;
    background-color: transparent;
    font-style: normal;
    font-weight: normal;
    font-size: ${({ fontSize }) => fontSize};
    color: #444a51;
    padding-left: 16px;
    padding-right: 32px;
    z-index: 1;

    -webkit-appearance: none;
    -moz-appearance: none;
    background: transparent;
    background-image: ${props => `url(${props.icon})`};
    background-repeat: no-repeat;
    background-position-x: calc(100% - 8px);
    background-position-y: 50%;

    ::placeholder {
      color: #bfc4ca;
    }

    :focus {
      #spanfocus {
        border-color: #106bef;
      }
    }

    -moz-appearance: none;
    -webkit-appearance: none;
  }

  select::-ms-expand {
    display: none;
  }

  button {
    position: absolute;
    right: 0;
    width: 47px;
    height: calc(100% + 2px);
    border: none;
    color: ${props => (props.focus ? '#ffffff' : '#5F6871')};
    border-left: ${({ borderLeft }) => (borderLeft ? '1px solid' : 'none')};
    border-radius: 0px 3px 3px 0px;
    border-color: ${props => (props.focus ? '#106bef' : '#bfc4ca')};
    background-color: ${props =>
      props.focus
        ? props.backgroundIcon
          ? '#106bef'
          : 'none'
        : 'transparent'};
    margin-right: -1px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon {
    margin-right: 13px;
  }

  :hover:not(:disabled) {
    border-color: #106bef;

    button {
      border-color: #106bef;
    }
  }

  ${({ disabled }) =>
    disabled &&
    css`
      background-color: #fafafb;

      :hover {
        border-color: #bfc4ca;

        button {
          border-color: #bfc4ca;
        }
      }

      button {
        z-index: 0;
      }
    `}

  ${({ error }) =>
    error &&
    css`
      border-color: #ea3e4f;

      :hover {
        border-color: #ea3e4f;

        button {
          border-color: #ea3e4f;
        }
      }

      button {
        border-color: #ea3e4f;
      }
    `}
`;

export const Message = styled.label<MessageProps>`
  display: flex;
  position: relative;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  color: #7b8591;
  margin-top: 8px;

  ${({ error }) =>
    error &&
    css`
      color: #ea3e4f;
    `}
`;
